import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[siStatus]',
  standalone: true,
})
export class StatusDirective {
  private _isPending: boolean;

  @Input()
  set siStatus(element: { isPending?: boolean }) {
    this._isPending = !!element.isPending;
  }

  @HostBinding('style.color')
  get textColor(): string {
    return this._isPending ? '#ff4d00' : '';
  }
}